var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"backButton",on:{"click":_vm.home}},[_c('i',{staticClass:"pi pi-arrow-circle-left"}),_c('span',{staticStyle:{"position":"relative","top":"-3px"}},[_vm._v(_vm._s(' ' + _vm.$t("Common.WeekOverView")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }